import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import handleAsyncThunk from "../handleAsyncThunk";
import cartApi from '../../services/cartApi';
import { showErrorSnackbar, showSuccessSnackbar } from './snackbarSlice';
import { deleteCart } from './cartSlice';

// Async thunk to handle the fetch request for the PaymentIntent
export const createPaymentButtonIntent = createAsyncThunk(
  'payment/createPaymentButtonIntent',
  async (data, { rejectWithValue, dispatch }) => {
    try {
      const response = await cartApi.paymentButtonIntent(data);
      if(response.status === 0){
        return response.data
      }else {
        dispatch(showErrorSnackbar({ title: response?.message }));
        return rejectWithValue(response.message);
      }
    } catch (error) {
      dispatch(showErrorSnackbar({ title: error?.message }));
      return rejectWithValue(error.message);
    }
  }
);

export const capturePaymentButtonIntent = createAsyncThunk(
  'payment/capturePaymentButtonIntent',
  async (data, { rejectWithValue, dispatch }) => {
    try {
      const response = await cartApi.capturePaymentButtonIntent(data);
      if(response.status === 0){
        dispatch(deleteCart());
        // TODO: Pass season Id { seasonId }
        dispatch(showSuccessSnackbar({ title: response?.data?.message }));
        return response.data
      }else {
        dispatch(showErrorSnackbar({ title: response?.message }));
        return rejectWithValue(response.message);
      }
    } catch (error) {
      dispatch(showErrorSnackbar({ title: error?.message }));
      return rejectWithValue(error.message);
    }
  }
);

const paymentSlice = createSlice({
  name: 'payment',
  initialState: {
    paymentButonResponse: null,
    isLoading: false,
    error: null,
  },
  reducers: {
    resetPaymentButtonIntentState: (state) => {
      state.paymentButonResponse = null;
    }
  },
  extraReducers: (builder) => {
    handleAsyncThunk(builder, createPaymentButtonIntent, 'paymentButonResponse', "paymentButtonError");
    handleAsyncThunk(builder, capturePaymentButtonIntent, 'paymentButonCaptureResponse', "paymentButtonCaptureError");
  }
});

export const { resetPaymentButtonIntentState } = paymentSlice.actions;

export default paymentSlice.reducer;
